import { render } from "./AddDispatch.vue?vue&type=template&id=5a61cea8&scoped=true"
import script from "./AddDispatch.vue?vue&type=script&lang=js"
export * from "./AddDispatch.vue?vue&type=script&lang=js"

import "./AddDispatch.vue?vue&type=style&index=0&id=5a61cea8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a61cea8"]])

export default __exports__